import api from "@/services/api/blockchainNetworks.js";
import { immerable } from "immer";
import { useCallback, useState } from "react";

class BlockchainNetwork {
	[immerable] = true;

	constructor(params) {
		this.networkId = params.networkId;
		this.name = params.name;
		this.label = params.label;
		this.explorerUrl = params.explorerUrl;
		this.$selected = params.$selected;
	}
}

const serialize = (data) => {
	return {
		networkId: data.networkId,
		name: data.name,
		label: data.label,
		explorerUrl: data.explorerUrl,
		$selected: data.$selected ?? false,
	};
};

const useBlockchainNetworks = (enabledNetworks) => {
	const [blockchainNetworks, setBlockchainNetworks] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const fetchBlockchainNetworks = useCallback(async () => {
		setLoading(true);
		setError(null);
		try {
			const [errorResponse, data] = await api.index();
			if (errorResponse) {
				setError(
					`Failed to fetch blockchain networks: ${errorResponse}`
				);
				return;
			}
			const networks = data.map(
				(data) => new BlockchainNetwork(data)
			);
			resetBlockchainNetworks(networks);

		} catch (error) {
			setError(`Failed to fetch blockchain networks: ${error}`);
		} finally {
			setLoading(false);
		}
	}, [enabledNetworks]);

	const resetBlockchainNetworks = (networks) => {
		const newNetworks = networks.map((entry) => {
			// Check if useCase has already enabled the network previously
			entry.$selected = enabledNetworks.includes(entry.networkId);
			return serialize(entry);
		});

		setBlockchainNetworks(newNetworks);
	};

	const toggleBlockchainNetwork = useCallback((networkId) => {
		setBlockchainNetworks((current) =>
			current.map((network) =>
				network.networkId === networkId
					? new BlockchainNetwork({ ...network, $selected: !network.$selected })
					: new BlockchainNetwork({ ...network })
			)
		);
	}, [blockchainNetworks]);

	const toggleAllBlockchainNetworks = useCallback((selected) => {
		setBlockchainNetworks((currentNetworks) =>
			currentNetworks.map((network) => ({
				...network,
				$selected: selected,
			}))
		);
	}, [blockchainNetworks]);


	return {
		blockchainNetworks,
		loading,
		error,
		toggleBlockchainNetwork,
		toggleAllBlockchainNetworks,
		fetchBlockchainNetworks,
		resetBlockchainNetworks,
	};
};

export default useBlockchainNetworks;
